/** @format */

module.exports = {
	icon:"Ícone",
    iconTip:"Clique para explorar os ícones disponíveis!"
};
